import { UserWithMetadata } from '@types';

import { ApiEndpointHandler, createGetEndpoint, getQueryString, HttpHeader } from '@sonar-software/sonar-http';
import { KeyPaginationQueryParams, PaginatedResource } from '@sonar-software/sonar-ts-types';

export type GetCustomerUsersRequest = KeyPaginationQueryParams & {
	customerId?: number;
	filter?: string;
	shardName?: string;
};

export type GetCustomerUsersResponse = PaginatedResource<UserWithMetadata>;

const getCustomerUsersBase = createGetEndpoint<GetCustomerUsersRequest, GetCustomerUsersResponse>(
	({ customerId, shardName, ...rest }) =>
		`/api/v3/core/customers/${customerId ?? 'current'}/users?${getQueryString(rest)}`,
	{
		headers: ({ shardName }) => {
			if (shardName) {
				return { [ HttpHeader.Shard ]: shardName };
			}

			return {};
		}
	}
);

export const getCustomerUsers: ApiEndpointHandler<GetCustomerUsersRequest, GetCustomerUsersResponse> = async(
	request,
	options
) => {
	const response = await getCustomerUsersBase(request, options);

	if (!response.data) {
		return response;
	}

	const users: Array<UserWithMetadata> = response.data.results.map((user) => ({
		...user,
		fullName: `${user.firstName} ${user.lastName}`
	}));

	response.data.results = users;

	return response;
};
